module.exports = __webpack_public_path__ + "static/media/eva-comby.b99b9ee7.png";